export const featureFlags = {
    budget: true,
}